import { Typography } from "@mui/material";
import { LINKS } from "shared/config";

export const DrawerFooter = () => {
  return (
    <Typography
      variant="caption"
      sx={{
        mt: "auto",
        width: "100%",
        p: 1.5,
        textAlign: "center",
        backgroundColor: "#002664",
      }}
    >
      <p className="text-cyan m-0">
        Created by{" "}
        <a
          href={LINKS.process_automation}
          rel="noreferrer"
          target="_blank"
        >
          &rarr; <i>Process Automation</i> &larr;
        </a>{" "}
        team
      </p>
    </Typography>
  );
};
